import { render, staticRenderFns } from "./bindRecord.vue?vue&type=template&id=57581660&scoped=true&"
import script from "./bindRecord.vue?vue&type=script&lang=js&"
export * from "./bindRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57581660",
  null
  
)

export default component.exports